import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-truck-info-panel',
    templateUrl: './truck-info-panel.component.html',
    styleUrls: ['./truck-info-panel.component.scss'],
    standalone: false
})
export class TruckInfoPanelComponent {

  @Input() identifier: string;

  @Input() carrier: string;

  @Input() driver: string;

  constructor(
    ) { }
}
